export default "__VITE_ASSET__DLMPGXAl__"